module.exports = __webpack_public_path__ + "static/media/chicureo_mobile.7f7e0734.jpg";